import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import './SellAllSharesDisclosure.scss';

import { getAllFundsByTicker } from '../../../redux/modules/funds/AllFunds/allFunds.selectors';
import { updateExchangeFund } from '../../../redux/modules/exchangeTransaction/exchangeTransaction.module';
import { ExchangeTransactionActionType } from '../../../redux/modules/exchangeTransaction';

import { getUserFundsByAgreementID } from '../../../redux/modules/funds/UserFunds/userFunds.selectors';
import {
  closeModal,
  SELL_ALL_SHARES_MODAL,
} from '../../../redux/modules/modals/modals.module';
import { updateSellFund } from '../../../redux/modules/sellTransaction/sellTransaction.module';
import { updateConversionFund } from '../../../redux/modules/rothConversionTransaction/rothConversionTransaction.module';
import { UNIT } from '../../../settings/settings';
import Button from '../../Shared/Button/Button';
import If from '../../Shared/If/If';
import {
  isAppSell,
  isCollegeExchange,
  isExchange,
  isSell,
  isCollegeDistribute,
  isRothConversion,
} from '../../../utils/transactions-util';
import words from '../../../utils/words';
import { isAPP } from 'src/utils/advice/advice-utility';

class SellAllSharesDisclosure extends Component {
  constructor(props) {
    super(props);
    this.handleButtonClick = this.handleButtonClick.bind(this);
  }

  handleButtonClick(clicked) {
    const {
      closeModal,
      fund: { agreementID, grossUnit, balanceAsOf },
      updateSellFund,
      updateExchangeFund,
      updateConversionFund,
    } = this.props;

    (isExchange() || isCollegeExchange()) &&
      updateExchangeFund(
        ExchangeTransactionActionType.UPDATE_EXCHANGE_FROM_FUND,
        {
          agreementID,
          closeout: clicked,
          inFocus: !clicked,
          grossAmount: undefined,
          grossUnit: clicked ? UNIT.ALL_SHARES : UNIT.DOLLARS,
        }
      );

    (isSell() || isCollegeDistribute() || isAppSell()) &&
      updateSellFund({
        agreementID,
        closeout: clicked,
        inFocus: !clicked,
        grossAmount: clicked ? 100 : 0,
        grossUnit: clicked ? UNIT.PERCENT : grossUnit,
      });

    // if roth conversion
    if (isRothConversion()) {
      updateConversionFund(
        agreementID,
        {
          closeout: clicked,
          inFocus: !clicked,
          grossAmount: 100,
          grossAmountDollars: clicked ? balanceAsOf : 0,
          grossUnit: clicked ? UNIT.PERCENT : UNIT.DOLLARS,
        },
        1
      );
    }

    closeModal(SELL_ALL_SHARES_MODAL);
  }

  render() {
    const { fund } = this.props;
    return (
      <div className="e2e-sell-all-shares-container">
        <div className="sell-all-shares-disclosure-heading">
          Close This{' '}
          {isAppSell() || isAPP(fund.productType) ? 'Account' : words.Fund}?
        </div>

        <div className="sell-all-shares-disclosure">
          This selection will{' '}
          {isAppSell() || isAPP(fund.productType)
            ? ''
            : `${words.sell} all owned ${words.shares} of this
        ${words.fund} and `}
          close the account.
          {isRothConversion() && (
            <div className="sell-all-shares-rothconversion">
              If you have an automatic transaction on this fund, it will
              automatically be deleted.
            </div>
          )}
          <If test={isSell()}>
            {' '}
            If the fund is open to new investors, initial investment minimums
            will apply.
          </If>
          <If test={isExchange() && !isAPP(fund.productType)}>
            {' '}
            If the fund is open to new investors, new fund minimums will apply.
          </If>
        </div>

        <div className="sell-all-shares-disclosure">
          <If test={isCollegeExchange()}>
            Any recurring contributions will not carry over to the new
            portfolio. If you intend to utilize Automatic Monthly Contributions
            or direct deposit moving forward, please navigate to the
            transactions menu after the trade is finalized.
          </If>
        </div>

        <div className="sell-all-shares-disclosure-button-container">
          <a
            className="trp-pdf-link e2e-sell-all-shares-cancel-button sell-all-shares-disclosure-cancel-button"
            id="sell-all-shares-disclosure-modal-cancel"
            onClick={() => {
              this.handleButtonClick(false);
              closeModal(SELL_ALL_SHARES_MODAL);
            }}
          >
            No thanks
          </a>

          <Button
            buttonType="primary"
            className="btn-trp-primary e2e-sell-all-shares-confirm-button sell-all-shares-disclosure-ok-button"
            id="sell-all-shares-disclosure-modal-ok"
            onClick={() => {
              this.handleButtonClick(true);
            }}
            styleName="sell-all-shares-disclosure-ok-button"
          >
            <b>OK</b>
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  allFundsByTicker: getAllFundsByTicker(state),
  userFundsByAgreementID: getUserFundsByAgreementID(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateExchangeFund,
      updateSellFund,
      updateConversionFund,
    },
    dispatch
  );

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  SellAllSharesDisclosure
);
